import React from 'react'
import * as Styled from './Label.styles'

const Label = ({
  height = null,
  labelRef = null,
  labelType = null, // 'contentfulLabel', 'brandyLabel'
  noPositionStyles = false,
  smallSpacing = false,
  text = null,
}) => (
  <Styled.Label
    className="package-label"
    noPositionStyles={noPositionStyles} // If we move the label permanently inside of the package cards, we can remove this
    ref={labelRef}
    height={height}
    labelType={labelType}
    dangerouslySetInnerHTML={{ __html: `${text}`.trim() }}
    smallSpacing={smallSpacing}
  />
)

/* eslint-enable react/no-danger */
export default Label
